module.exports = __webpack_public_path__ + "static/media/bkst_site_games_header.4febd38e.jpg";